import { Router } from 'vue-router';
import { AuthorizationError } from '@/shared/utils/errors';
import { routeIsAuthorized } from '../util';

export default function setupAuthorizationGuard(router: Router): void {
  router.beforeEach(async (to, from, next) => {
    if (routeIsAuthorized(to)) {
      next();
    } else {
      next(new AuthorizationError());
    }
  });
}
